import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _Optional;
/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

//a java-style optional. Typescript ?. chaining is great,
// but doesn't work in cases where your possibly-null object is an argument
// to the next function in the chain, rather than the owner of the function.

import { Supplier } from "abweb/utils/Supplier";
export class Optional {
  constructor(value) {
    _defineProperty(this, "filter", filterFunc => {
      if (this.isPresent() && filterFunc(this.value)) {
        return this;
      }
      return Optional.EMPTY;
    });
    _defineProperty(this, "filterType", filterFunc => {
      if (this.isPresent() && filterFunc(this.value)) {
        return Optional.of(this.value);
      }
      return Optional.EMPTY;
    });
    this.value = value;
  }
  get isEmpty() {
    return this === Optional.EMPTY;
  }
  static of(q) {
    return q == null ? Optional.EMPTY : new Optional(q);
  }
  isPresent() {
    return !this.isEmpty;
  }
  ifPresent(isPresentConsumer, callIfNotPresentFunc) {
    this.isPresent() ? isPresentConsumer(this.value) : callIfNotPresentFunc?.();
  }
  get() {
    return this.isPresent() ? this.value : undefined;
  }
  map(mapper) {
    if (this.isPresent()) {
      return Optional.of(mapper(this.value));
    }
    return Optional.EMPTY;
  }
  flatMap(mapper) {
    if (this.isPresent()) {
      return mapper(this.value);
    } else {
      return Optional.EMPTY;
    }
  }
  orElse(otherValueSupplier) {
    return this.isPresent() ? this.value : Supplier.resolve(otherValueSupplier);
  }
  orElseThrow(errorSupplier) {
    if (this.isPresent()) {
      return this.value;
    }
    throw Supplier.resolveError(errorSupplier);
  }
  toString() {
    if (this.isPresent()) {
      return "Optional[" + this.value + "]";
    }
    return "Optional.empty";
  }
}

/*export type Empty = false | undefined | void | null;
export type Optional<T> = T extends Empty ? undefined : T;
export type NotEmpty<T> = T extends Empty ? never : T;

export class Opt
{
  public static readonly map = <T,Q>(t: Optional<T>, m: (t: NotEmpty<T>) => Q): Optional<Q> => {};
  public static readonly get = <T>(t: T)
}*/
_Optional = Optional;
_defineProperty(Optional, "EMPTY", new _Optional(undefined));
//# sourceMappingURL=Optional.js.map
